import { useEffect } from "react";
import classNames from "classnames";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import Modal from "../Modal";
import { getTxDetailsLink } from "@helpers/metamask";
import { getEllipsisText } from "@helpers/common";
import { submitTransferReset } from "@redux/payments/actions";
import { ReactComponent as IconPending } from "../../assets/ic-pending.svg";

import styles from "./index.module.scss";
import routes from "../../const/routes";

const TxModal = ({ toggleModal, formId }) => {
  const { t } = useTranslation("modals");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state = {} } = useLocation();

  const NUMBER_OF_FIRST_CHARACTERS = 16;
  const NUMBER_OF_FIRST_CHARACTERS_MOBILE = 9;
  const NUMBER_OF_LAST_CHARACTERS = 4;

  const { from = routes.FEED() } = state || {};

  const { pendingPayments } = useSelector(
    ({ paymentsReducer }) => paymentsReducer,
  );

  useEffect(() => {
    if (pendingPayments?.length) {
      navigate(from, { replace: true });
    }
  }, [from, pendingPayments]);

  const isOpen = !!pendingPayments?.length;

  const toggle = () => dispatch(submitTransferReset());

  return (
    <Modal
      unmountOnClose
      size="md"
      onClose={toggle}
      toggle={toggle}
      isOpen={isOpen}
      className={styles.modalContainer}
      onCancel={toggleModal}
      title={t("TX_TITLE")}
      confirmType="submit"
      confirmForm={formId}
      bodyClassName="mt-1"
      footerClassName="d-none"
    >
      <div className="d-flex align-items-center justify-content-center">
        <IconPending className="me-2 spinner-border border-0" />
        <div className="ps-1 subtitle-2 text-medium">{t("TX_PROCESSING")}</div>
      </div>
      <div
        className={classNames(
          "mb-4 text-center text-body-1 text-regular text-primary",
          styles.text,
        )}
      >
        {t("TX_BODY")}
      </div>
      <div className="mb-3 pb-3 text-center text-body-1 text-medium text-tertiary">
        {t("TX_HASH")}
        <a
          href={getTxDetailsLink(pendingPayments.at(-1))}
          target="_blank"
          rel="noopener noreferrer"
          className="ms-2 text-decoration-none text-medium link-orange d-none d-xl-inline"
        >
          {getEllipsisText(
            pendingPayments.at(-1),
            NUMBER_OF_FIRST_CHARACTERS,
            NUMBER_OF_LAST_CHARACTERS,
          )}
        </a>
        <a
          href={getTxDetailsLink(pendingPayments.at(-1))}
          target="_blank"
          rel="noopener noreferrer"
          className="ms-2 text-decoration-none text-medium link-orange d-xl-none"
        >
          {getEllipsisText(
            pendingPayments.at(-1),
            NUMBER_OF_FIRST_CHARACTERS_MOBILE,
            NUMBER_OF_LAST_CHARACTERS,
          )}
        </a>
      </div>
    </Modal>
  );
};

export default TxModal;
